import React from 'react';
import { useAuth } from './AuthProvider';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const { auth } = useAuth();
  
  if (!auth.isAuthenticated && auth.userRole !== 'Admin') {
    return <Navigate to="/login" />;
  }

  return children;
};

export default PrivateRoute;
